import script from "./permisoPlantillaForm.vue?vue&type=script&setup=true&lang=js"
export * from "./permisoPlantillaForm.vue?vue&type=script&setup=true&lang=js"

import "./permisoPlantillaForm.vue?vue&type=style&index=0&id=1165bb63&scoped=true&lang=css"
import "./permisoPlantillaForm.vue?vue&type=style&index=1&id=1165bb63&lang=css"
import "./permisoPlantillaForm.vue?vue&type=style&index=2&id=1165bb63&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1165bb63"]])

export default __exports__